import React from 'react';
import { TextField } from '@mui/material';
import ConfirmDialog from '../../../shared/components/ConfirmDialog';

interface Props {
  open: boolean;
  /** The gated step, named so the operator confirms the gate in front of them. */
  stepLabel: string;
  /** Supplied where the surface has no note field of its own; omitted where it already has one. */
  note?: string;
  onNoteChange?: (note: string) => void;
  onCancel: () => void;
  onConfirm: () => void;
}

// One home for the rule that rejecting a gate ends the run. Both surfaces that offer it must say
// so in the same words: a second copy is how one of them ends up warning about a smaller act than
// it performs.
const WorkflowStopRunDialog: React.FC<Props> = ({
  open,
  stepLabel,
  note,
  onNoteChange,
  onCancel,
  onConfirm,
}) => (
  <ConfirmDialog
    open={open}
    title={`Stop the run at ${stepLabel}?`}
    onCancel={onCancel}
    onConfirm={onConfirm}
    confirmText="Stop run"
    confirmColor="error"
  >
    Rejecting this gate ends the whole run, not just this step. It keeps what it recorded so far
    and cannot be restarted. Any note you typed is recorded with it.
    {onNoteChange && (
      <TextField
        fullWidth
        size="small"
        label="Note"
        value={note ?? ''}
        onChange={(e) => onNoteChange(e.target.value)}
        helperText="Optional: recorded against your rejection"
        sx={{ mt: 2 }}
      />
    )}
  </ConfirmDialog>
);

export default WorkflowStopRunDialog;
